const boolTermsEnum = {
  AND: 'AND',
  OR: 'OR',
  NOT: 'NOT'
};
    
export default boolTermsEnum;